module.exports = __webpack_public_path__ + "static/media/Cheri Liney-01.a3e8a52e.svg";